import type { QueryClient } from '@tanstack/react-query';
import { PolicyKey } from '@kirin/api-client/contracts/policies';

/**
 * After a packages-management rule changes, refetch every Packages table so
 * its State column is not served stale until `staleTime` runs out.
 *
 * Every scope's table is invalidated rather than working out which one the
 * rule was written in: it is one cheap refetch, and keying it to the scope
 * would couple this helper to the table's query-key layout.
 */
export function invalidatePackageListState(
  queryClient: QueryClient,
  policyKey: string | undefined
): void {
  if (policyKey !== PolicyKey.PackagesManagement) return;
  void queryClient.invalidateQueries({
    predicate: query =>
      query.queryKey[0] === 'agent-command-events' &&
      query.queryKey[2] === 'aggregated-packages',
  });
}
